import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { Router } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { TabMenu, TabMenuModule } from 'primeng/tabmenu';
import { MessageService } from 'primeng/api';
import { AbstractView } from '@core/interfaces';
import { TabMenuViewPresenter } from './interfaces';
import { SharedModule } from '@shared/shared.module';
import { ComponentHostDirective } from './directives/component-host.directive';
import { TabMenuService } from './services/tab-menu.service';
import { TabComponent } from './interfaces/tab-component';
import { TabMenuPresenter } from './tab-menu.presenter';
import { MenuItemExtended } from '@core/interfaces/menu-item-extended';
import { BehaviorSubject, Observable } from 'rxjs';
import { Store } from '@ngrx/store';

@Component({
  selector: 'app-tab-menu',
  standalone: true,
  imports: [
    SharedModule,
    ButtonModule,
    TabMenuModule,
    ComponentHostDirective,
  ],
  templateUrl: './tab-menu.component.html',
  styleUrl: './tab-menu.component.scss',
  providers: [
    TabMenuPresenter,
  ],
})
export class TabMenuComponent<T = undefined, P = undefined>
  extends AbstractView<TabMenuPresenter<T, P>>
  implements TabMenuViewPresenter<T>, OnInit, OnDestroy
{
  @Input() activeTab: MenuItemExtended<T> | undefined;
  @Input({ required: true }) routeItems: MenuItemExtended<T>[] = [];
  @Input() routeItemsEnabled$: Observable<string[]> = new BehaviorSubject<string[]>([]);
  @Output() activeTabChange = new EventEmitter<MenuItemExtended<T>>();
  routeItemsFrezeze!: MenuItemExtended<T>[];

  lastTab: MenuItemExtended<T> | undefined;
  cdr: ChangeDetectorRef;

  @ViewChild(TabMenu) tabMenu!: TabMenu;
  
  constructor(
    messageService: MessageService,
    router: Router,
    store: Store,
    presenter: TabMenuPresenter<T, P>,
    private tabMenuService: TabMenuService,
    cdr: ChangeDetectorRef,
  ) {
    super(messageService, router, store, presenter);
    this.cdr = cdr;
  }

  ngOnInit(): void {
    this.presenter.setView(this);
  }

  ngOnDestroy(): void {
    this.onTabChange(this.routeItems[0]);
    this.tabMenuService.clearForms();
  }

  onComponentInstanceCreated(instance: T): void {
    this.tabMenuService.registerForm(instance as TabComponent);
  }

  onTabChange(tab: MenuItemExtended<T> | undefined): void {
    this.presenter.onTabChange(tab);
  }

  onDefaultTab(): void {
    this.presenter.onDefaultTab();
  }

  validateCurrentTab(): boolean {
    if (this.activeTab?.id !== undefined) {
      return this.tabMenuService.validateTab(this.activeTab.id);
    }
    return true;
  }
}
